import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { S3_BASE_URL } from "@constants/constants";
import { getMediaType } from "@helpers/helpers";

const ViewModal = ({ show, onCloseClick, data }) => {

  const mediaType = getMediaType(data);

  return (

    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>

      <div className="modal-content">

        <ModalBody className="px-4 py-5 text-center">

          <button
            type="button"
            onClick={onCloseClick}
            className="btn-close position-absolute end-0 top-0 m-3"
          >
          </button>

          {mediaType === "image" && (

            <img src={S3_BASE_URL + data} alt="Image" className="img-fluid" />

          )}
          {mediaType === "video" && (

            <video controls className="img-fluid">

              <source
                src={data}
                type={`video/${new URL(data).pathname.split(".").pop().toLowerCase()}`}
                />

              Your browser does not support the video tag.

            </video>
          )}
          {mediaType === "audio" && (

            <>
              <audio controls>  

                <source src={data} type="audio/wav"></source>

              </audio>

            </>
          )}
          {mediaType === "unknown" && <p>Unsupported media type</p>}

        </ModalBody>

      </div>

    </Modal>
  );
};

ViewModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.any,
};

export default ViewModal;
